import React from "react";
import { Typography, Button } from "@arco-design/web-react";
import { IconCopy, IconCheckCircle } from "@arco-design/web-react/icon";

const { Title, Paragraph, Text } = Typography;

interface CodeExampleSectionProps {
	className?: string;
}

const CodeExampleSection: React.FC<CodeExampleSectionProps> = ({
	className,
}) => {
	const [copied, setCopied] = React.useState(false);

	const codeExample = `# 获取相关知识点
curl -X POST "${window.location.origin}/api/arg-slice/slice/content" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -d '{
    "query": "什么是医疗器械注册？",
    "limit": 5,
    "queryType": "simple"
  }'`;

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(codeExample);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (err) {
			console.error("Failed to copy text: ", err);
		}
	};

	return (
		<section className={`code-example-section ${className || ""}`}>
			<div style={{ maxWidth: "1200px", margin: "0 auto" }}>
				{/* 标题区域 */}
				<div className="code-example-title-section">
					<Title heading={2} className="code-example-title">
						快速开始
					</Title>
					<Paragraph className="code-example-subtitle">
						只需几行代码，即可开始使用我们的API服务
					</Paragraph>
				</div>

				{/* 代码示例区域 */}
				<div className="code-block-container">
					{/* 代码块 */}
					<div className="code-block">
						{/* 装饰性背景 */}
						<div className="code-block-decoration" />

						{/* 代码头部 */}
						<div className="code-block-header">
							<div className="code-block-header-left">
								<div className="terminal-dot red"></div>
								<div className="terminal-dot yellow"></div>
								<div className="terminal-dot green"></div>
								<Text className="terminal-label">Terminal</Text>
							</div>

							<Button
								// type="text"
								size="small"
								onClick={handleCopy}
								className={`copy-button ${copied ? "copy-success" : ""}`}
							>
								{copied ? (
									<>
										<IconCheckCircle style={{ marginRight: "4px" }} />
										已复制
									</>
								) : (
									<>
										<IconCopy style={{ marginRight: "4px" }} />
										复制
									</>
								)}
							</Button>
						</div>

						{/* 代码内容 */}
						<pre className="code-content">
							<code>
								<span className="code-keyword"># 获取相关知识点</span>
								<br />
								<span style={{ color: "#fbbf24" }}>curl</span> -X POST "
								{window.location.origin}/api/arg-slice/slice/content" \
								<br />
								&nbsp;&nbsp;-H "Content-Type: application/json" \
								<br />
								&nbsp;&nbsp;-H "Authorization: Bearer YOUR_JWT_TOKEN" \
								<br />
								&nbsp;&nbsp;-d '&#123;
								<br />
								&nbsp;&nbsp;&nbsp;&nbsp;"query": "什么是医疗器械注册？",
								<br />
								&nbsp;&nbsp;&nbsp;&nbsp;"limit": 5,
								<br />
								&nbsp;&nbsp;&nbsp;&nbsp;"queryType": "simple"
								<br />
								&nbsp;&nbsp;&#125;'
							</code>
						</pre>
					</div>

					{/* 使用说明 */}
					<div className="usage-note">
						<Text className="usage-note-text">
							💡 替换 <code className="usage-note-code">YOUR_JWT_TOKEN</code>{" "}
							为您的实际JWT令牌
						</Text>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CodeExampleSection;
